import { sendEvent } from "@helpers/Analytics";
import useFeatureFlag from "@hooks/useFeatureFlag";

const useAnalytics = () => {
  const { enable_testing } = useFeatureFlag();

  const logTestingEvent = (action, label) => {
    console.log(
      `%cTest flag enabled, skipping GA event: ${action} - ${label}`,
      "color: #fbd911"
    );
  };

  return {
    sendEvent: enable_testing ? logTestingEvent : sendEvent,
  };
};

export default useAnalytics;
